<div class="initial-avatar">{{initial}}</div>